import { render, staticRenderFns } from "./WpLabResultReportAI.vue?vue&type=template&id=22e82e54&scoped=true"
import script from "./WpLabResultReportAI.vue?vue&type=script&lang=js"
export * from "./WpLabResultReportAI.vue?vue&type=script&lang=js"
import style0 from "./WpLabResultReportAI.vue?vue&type=style&index=0&id=22e82e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e82e54",
  null
  
)

export default component.exports